var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.796875,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0A77C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.3749V19.4999H8.625L17.8417 10.2832L14.7167 7.15822L5.5 16.3749ZM20.2583 7.86655C20.5833 7.54155 20.5833 7.01655 20.2583 6.69155L18.3083 4.74155C17.9833 4.41655 17.4583 4.41655 17.1333 4.74155L15.6083 6.26655L18.7333 9.39155L20.2583 7.86655Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSource);
export default __webpack_public_path__ + "static/media/edit-source.a55b8bf58316032984b7979d779161b8.svg";
export { ForwardRef as ReactComponent };